import React from 'react';

const AboutUs = () => {
  return (
    <div className="page-container">
      <h1>About Our Company</h1>
      <div className="about-content">
        <section>
          <h2>Our Story</h2>
          <p>Founded in 2010, Go Trip has been helping travelers explore the world with unforgettable experiences.</p>
        </section>
        <section>
          <h2>Our Team</h2>
          <p>We're a group of passionate travelers dedicated to creating perfect vacations for our clients.</p>
        </section>
        <section>
          <h2>Our Mission</h2>
          <p>To make world travel accessible, enjoyable, and memorable for everyone.</p>
        </section>
      </div>
    </div>
  );
};

export default AboutUs;